<template>
  <res-dialog :title="titleMessage"
              :showDialog="showDialog"
              :smallTitleIcon="true"
              :cancelButtonOnly="true"
              :cancelButtonTextColor="'primary--text'"
              :cancelButtonColor="'primary'"
              :cancelButtonText="'OK'"
              :cancelButtonWidth="'80'"
              :iconColor="'white'"
              :iconTitle="iconCode"
              :showTitleIcon="true"
              :titleClass="'resBlue darken-1 white--text'"
              @cancel="cancelInfo">
    <v-card-text>
      <span>
        {{ dialogMessage }}
      </span>
      <slot></slot>
    </v-card-text>
  </res-dialog>
</template>

<script>
  import ResDialog from '@/components/base/ResDialog.vue';

  export default {
    components: {
      ResDialog
    },
    data: function () {
      return {
        setHeight: '30'
      };
    },
    props: ['showDialog', 'message', 'title', 'iconTitle'], 
    methods: {
      cancelInfo() {
        this.$emit('cancelError', true)
      }
    },
    computed: {
      dialogMessage() {
        if (this.message !== undefined && this.message !== null) {
          return this.message
        } else {
          return 'Something went wrong! Please try again or contact support for further assistance.'
        }
      },
      titleMessage() {
        if (this.title !== undefined && this.title !== null) {
          return this.title
        } else {
          return 'Info'
        }
      },
      iconCode() {
        if (this.iconTitle) {
          return this.iconTitle;
        }
        return 'info';
      },
      calculateHeight() {
        return "height:" + this.setHeight + "px";
      }
      
    }
  }
</script>
